import React from 'react';
import './App.css';
import './style.css';
import Home from "./components/Home.js";
import Refactoring from "./components/Refactoring.js";
import Diagram from "./components/Diagram";
import { BrowserRouter, Route, Switch, Redirect, HashRouter } from "react-router-dom";
import Navbar from './Nav';

function App() { 
  return (
    <div>
      <Navbar />
          <BrowserRouter>
            <div>
                <Switch>
                  <HashRouter basename={process.env.PUBLIC_URL}>
                    <Route exact path="/:refactoring/:cod" component={Refactoring} />
                    <Route exact path="/:diagram/" component={Diagram} />
                    <Route exact path="/" component={Home} />
                    <Route exact path="/">
                      <Redirect from="/" exact to="/"/>
                    </Route>
                  </HashRouter>
                </Switch>
            </div>
          </BrowserRouter>
    </div>

  );
}


export default App;
